import { Box, Button, Stack, Typography } from '@mui/material';
import useDialog from '../hooks/useDialog';
import { trandingCompanyName, trandingPhone, trandingUEN } from '../constants';
import QRCode from 'react-qr-code';
import { generatePayNowStr } from '../paynow';
import moment from 'moment';
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export default function TopUpBrandBalanceDialog() {
  const dialog = useDialog();
  const authCtx = useContext(AuthContext);

  return (
    <Stack direction="column" spacing={2}>
      <Typography component="p">
        Scan this PayNow QR code to top-up your balance with Tranding, then{' '}
        <a
          href={`https://api.whatsapp.com/send/?phone=65${trandingPhone}&text&type=phone_number&app_absent=0`}>
          WhatsApp a screenshot to {trandingPhone}
        </a>
        {'.'}
      </Typography>
      <Typography component="p">
        Alternatively, make a PayNow to {trandingUEN}, enter your full company
        name in the reference, then{' '}
        <a
          href={`https://api.whatsapp.com/send/?phone=65${trandingPhone}&text&type=phone_number&app_absent=0`}>
          WhatsApp a screenshot to {trandingPhone}
        </a>
        {'.'}
      </Typography>
      <Box display="flex" justifyContent="center">
        <QRCode
          size={192}
          value={generatePayNowStr({
            uen: trandingUEN,
            editable: true,
            expiry: moment(new Date()).add(1, 'day').format('YYYYMMDD'),
            amount: 0,
            companyName: trandingCompanyName,
            refNumber: `${
              authCtx.merchantName
            }-${authCtx.merchantId!.toString()}`,
          })}
        />
      </Box>
      <Stack justifyContent="end" direction="row" spacing={2}>
        <Button
          onClick={() => {
            dialog.handleDialogClose();
          }}>
          Close
        </Button>
      </Stack>
    </Stack>
  );
}
